// extracted by mini-css-extract-plugin
export default {"container":"UserNav_container__xkjhO","link":"UserNav_link__fvLX5","text":"UserNav_text__jQFOm"};